// extracted by mini-css-extract-plugin
module.exports = {"budgetQuestion":"BesoinAideQuest_budgetQuestion__N0Hi5","purpleBar":"BesoinAideQuest_purpleBar__bvQ42"};